import Header from "./header";
import Content from "./content";

export const DocResource = {
	Header: Header,
	Content: Content,
}
